"use strict";
var $ = require("jquery");
var Clipboard = require("clipboard");
var GiftCodeUtils = (function () {
    function GiftCodeUtils() {
    }
    GiftCodeUtils.init = function () {
        var _this = this;
        $(document).ready(function () {
            var firstRun = _this.clipboard === null;
            _this.clipboard = new Clipboard(".gift-code-to-copy", {
                text: function (el) { return $(el).attr("data-clipboard"); }
            });
            _this.clipboardShare = new Clipboard(".btn-share-gift", {
                text: function (el) { return $(el).attr("data-clipboard"); }
            });
            if (firstRun) {
                _this.clipboard
                    .on("success", function (e) {
                    alert("Подарочный код скопирован");
                })
                    .on("error", function (e) {
                    var $el = $(e.trigger);
                    var data = $el.attr("data-clipboard");
                    prompt("Подарочный код", data);
                });
                _this.clipboardShare
                    .on("success", function (e) {
                    alert("Сообщение скопировано");
                })
                    .on("error", function (e) {
                    var $el = $(e.trigger);
                    var data = $el.attr("data-clipboard");
                    prompt("Сообщение", data);
                });
            }
        });
    };
    GiftCodeUtils.clipboard = null;
    GiftCodeUtils.clipboardShare = null;
    return GiftCodeUtils;
}());
if (!window["AppUtils"])
    window["AppUtils"] = {};
window["AppUtils"].GiftCodes = GiftCodeUtils;
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = GiftCodeUtils;
//# sourceMappingURL=giftCodeUtils.js.map